import React, { useEffect } from 'react';
// import ReactGA from 'react-ga4';

const Step3 = ({ formData, handleInputChange, setStep }) => {
  useEffect(() => {
    // ReactGA.event({
    //   category: 'Navigation',
    //   action: 'Page View',
    //   page_name: pageName
    // });
  }, []);

  useEffect(() => {
    sessionStorage.setItem('lastPage', 'Step3');
  }, []);

  // dentalIssueの初期値をfalseにする
  useEffect(() => {
    if (formData.dentalIssue === undefined) {
      handleInputChange({ target: { name: 'dentalIssue', value: null } });
    }
  }, [formData, handleInputChange]);

  const handleFormSubmit = (answer) => {
    handleInputChange({ target: { name: 'dentalIssue', value: answer === 'yes' } });
    setStep(5);
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">ステップ 3</h2>
      <p className="text-base mb-4 text-lg">現在、抜歯が必要なむし歯や歯周病があると言われていますか？<br /><br />
        <span className="underline-wavy text-red-500">※不明な場合は、「いいえ」を選んでください。</span>
      </p>
      <br />
      <div className="flex justify-between">
        <button 
          onClick={() => setStep(3)} 
          className="bg-gray-500 text-white p-2 rounded hover:bg-gray-600 w-auto"
        >
          前の画面へもどる
        </button>
        <button 
          onClick={() => handleFormSubmit('yes')} 
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto"
        >
          はい
        </button>
        <button 
          onClick={() => handleFormSubmit('no')} 
          className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto"
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default Step3; 